import Title from "../components/Title";
import Gallery from "../components/gallery/Gallery";
import useLocalization from "../hooks/use-localization";

export default function PhotoGalleryPage() {

    const localization = useLocalization();

    return (<>
        <Title value={localization.photoGallery}></Title>
        <Gallery />
    </>);
}